import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { AlertWarningCircleIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorIconDestructive, colorTextDestructive } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { hasToManyEmails, getEmailErrorMessage } from './get_validation_schema';
const containerCss = "c1o75jfy";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const wrapperCss = "w1p4eunp";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const Errors = () => {
  const {
    errors: {
      subject: subjectError,
      body: bodyError,
      to: toError,
      ...errors
    },
    values,
    touched: {
      to: isToTouched
    }
  } = useFormContext();
  const errorMessages = [];
  const emailError = getEmailErrorMessage();
  const hasAnyInvalidEmail = field => Array.isArray(errors[field]) && errors[field].filter(Boolean).every(({
    email
  }) => email === emailError);
  if (hasAnyInvalidEmail('cc') || hasAnyInvalidEmail('bcc')) {
    errorMessages.push(I18n.t('publisher.send_from_calendly.errors.invalid_email'));
  }
  if (hasToManyEmails(values)) {
    errorMessages.push(I18n.t('publisher.send_from_calendly.errors.too_many_emails'));
  }
  if (toError && isToTouched) {
    errorMessages.push(I18n.t('publisher.send_from_calendly.errors.to_field'));
  }
  if (subjectError) {
    errorMessages.push(subjectError);
  }
  if (bodyError) {
    errorMessages.push(bodyError);
  }
  if (!errorMessages.length) {
    return null;
  }
  return <Container>
      {errorMessages.map((message, index) => <Wrapper key={`error-${index + 1}`}>
          <AlertWarningCircleIcon spacingRight={8} color={colorIconDestructive} />
          <BodyText size="medium" color={colorTextDestructive}>
            {message}
          </BodyText>
        </Wrapper>)}
    </Container>;
};

require("./errors.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./errors.js");